<template>
  <div>
    <!-- <el-row>
      <h2>已检测</h2>
    </el-row>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="检测日期：">
            <el-date-picker v-model="searchForm.date" type="date" placeholder="选择日期" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="queryTable(0)" style="float:right">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row> -->
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="ITEM_NAME" label="检测项"></el-table-column>
          <el-table-column prop="ITEM_STANDARD" label="项目标准"></el-table-column>
          <el-table-column prop="ITEM_VALUE" label="检测值"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="openEdit(scope.row)">修改</el-button>
              <el-button type="text" @click="deleteRecord(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="修改检测值" center :visible.sync="editFormVisible" width="400px">
      <el-form :model="editForm" ref="editForm">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <span>{{ editForm.NAME }}</span>
        </el-form-item>
        <el-form-item label="检测值：" :label-width="formLabelWidth">
          <el-input v-model="editForm.ITEM_VALUE"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitEdit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { queryhaveCheck, deleteFun, editRecordFun } from 'api/checkDoc';
import date from '@/assets/common/date';
// import { getFormatDay } from '@/assets/common/common';

export default {
  props: {
    searchForm1: {
      type: Object,
      default: null,
    },
    currentPage1: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      // searchForm: {
      //   date: getFormatDay(1, '-'),
      // },
      // currentPage: 1,
      searchForm: this.searchForm1,
      currentPage: this.currentPage1,
      pageSize: 15,
      totalCount: 0,
      tableData: [],
      editFormVisible: false,
      editForm: {},
      name: '',
      formLabelWidth: '100px',
      loading: false,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    // if (this.SAVE_DSORDER_LIST) {
    //   this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
    //   this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    // } else {
    //   this.currentPage = 1;
    // }
    // this.queryTable(0);
  },
  methods: {
    queryTable(pageIndex) {
      const params = {
        FTS_DAY: date(this.searchForm.date, '%F'),
        PAGEINDEX: pageIndex,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      queryhaveCheck(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable(e - 1);
    },
    deleteRecord(row) {
      const params = {
        ITEM_ID: row.ID,
      };
      deleteFun(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryTable(0);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openEdit(row) {
      this.editForm = row;
      this.editFormVisible = true;
    },
    submitEdit() {
      this.loading = true;
      const params = {
        ITEM_ID: this.editForm.ID,
        ITEM_VALUE: this.editForm.ITEM_VALUE,
      };
      editRecordFun(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.queryTable(0);
        this.editFormVisible = false;
        this.loading = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
    close() {
      this.editFormVisible = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/foodSecurity/haveCheckDoc.vue